import { createFileRoute } from '@tanstack/react-router';
import TrainingAdmin from 'containers/TrainingAdmin';

export const Route = createFileRoute('/_authenticated/trainingAdmin')({
  component: TrainingAdmin,
});
